import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { CLIENT_API_BASE } from '@core/config/client-api.token';
import { ANONYMOUS_REQUEST } from '@core/http/anonymous-request.context';
import { map } from 'rxjs';
import { IAccountDeletionRepository } from '../../domain/repositories/account-deletion.repository';
import { AccountDeletionAcceptedDto, mapAccountDeletionAccepted } from '../dtos/account-deletion.dto';

@Injectable()
export class AccountDeletionRepository implements IAccountDeletionRepository {
  private readonly http = inject(HttpClient);
  private readonly base = `${inject(CLIENT_API_BASE)}/account-deletion`;
  private readonly options = { context: new HttpContext().set(ANONYMOUS_REQUEST, true) };

  requestVerification(email: string, language: string) {
    return this.http.post<void>(`${this.base}/request-verification`, { email, language }, this.options);
  }
  confirm(token: string) {
    return this.http.post<AccountDeletionAcceptedDto>(`${this.base}/confirm`, { token, confirmed: true }, this.options)
      .pipe(map(mapAccountDeletionAccepted));
  }
  cancel(token: string) {
    return this.http.post<void>(`${this.base}/cancel`, { token }, this.options);
  }
}
